import ReactDocumentTitle from "~/components/ReactDocumentTitle";
import React from "react";
import {createUseStyles} from "react-jss";
import {useQuery} from "@apollo/client";
import gql from "graphql-tag";
import {filter} from "graphql-anywhere";
import AppLayout from "~/layouts/AppLayout";
import EntityBackToListLink from "~/components/EntityBackToListLink";
import AccountHead from "../../components/AccountHead";
import UITabs, {UITab} from "~/old-ui/UITabs";
import {useHistory, useParams} from "react-router";
import useQueryParam from "~/hooks/useQueryParam";
import {createSetQueryParamUrl} from "~/utils";
import useLoadingEffect from "~/hooks/useLoadingEffect";
import UnexpectedErrorScene from "~/scenes/system/UnexpectedErrorScene";
import ReactLink from "~/components/ReactLink";

export default function AccountDetailScene() {
  const classes = useStyles();

  const history = useHistory();
  const {id} = useParams();
  const selectedTab = useQueryParam(history, 'tab');
  const showLoadingEffect = useLoadingEffect();

  const {data, error} = useQuery(query, {
    variables: {id}
  });

  const account = data ? data.account : null;

  if (error) {
    return <UnexpectedErrorScene
      error={error}
    />
  }

  return (
    <>
      <ReactDocumentTitle title={account ? account.name : 'Loading'}/>

      <AppLayout>
        {(!!data || showLoadingEffect) && (
          <>
            <div className={classes.backToListContainer}>
              <EntityBackToListLink url={'accounts_list'}/>
            </div>

            <AccountHead
              account={account ? filter(AccountHead.fragments.account, account) : null}
            />

            <UITabs className={classes.tabs}>
              <UITab
                tagName={ReactLink}
                to={createSetQueryParamUrl(history, {tab: null})}
                selected={selectedTab === null}
              >Information</UITab>

              <UITab
                tagName={ReactLink}
                to={createSetQueryParamUrl(history, {tab: 'payment'})}
                selected={selectedTab === 'payment'}
              >Ticket & payment</UITab>

              <UITab
                tagName={ReactLink}
                to={createSetQueryParamUrl(history, {tab: 'evaluation'})}
                selected={selectedTab === 'evaluation'}
              >Evaluation</UITab>
            </UITabs>


          </>
        )}
      </AppLayout>
    </>
  )
}


const useStyles = createUseStyles({
  backToListContainer: {
    margin: [[12, 0, 24]]
  },

  tabs: {
    marginTop: 20,
  },

  tabContent: {
    marginTop: 20,
    marginBottom: 40,
  },
});

const query = gql`
  query AccountDetailQuery($id: ID!) {
    account: getAccount(accountId: $id) {
      id
      __typename
      name
      active
      isTrial
      trial {
        endsIn
      }
    }
  }
`;

